import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconJobProgramCode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 6.50003C8 7.05232 7.55229 7.5 7 7.5C6.44771 7.5 6 7.05232 6 6.50003C6 5.94774 6.44771 5.5 7 5.5C7.55229 5.5 8 5.94774 8 6.50003Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.53033 11.4697L9.53033 13.4697C9.82322 13.7626 9.82322 14.2374 9.53033 14.5303L7.53033 16.5303C7.23744 16.8232 6.76256 16.8232 6.46967 16.5303C6.17678 16.2374 6.17678 15.7626 6.46967 15.4697L7.93934 14L6.46967 12.5303C6.17678 12.2374 6.17678 11.7626 6.46967 11.4697C6.76256 11.1768 7.23744 11.1768 7.53033 11.4697Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 16.25C9.58579 16.25 9.25 16.5858 9.25 17C9.25 17.4142 9.58579 17.75 10 17.75H13C13.4142 17.75 13.75 17.4142 13.75 17C13.75 16.5858 13.4142 16.25 13 16.25H10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.25 6.50002V17.2522C3.25 19.1597 4.74831 20.75 6.66521 20.75H17.3348C19.2399 20.75 20.75 19.1719 20.75 17.2522V6.50002C20.75 4.66029 19.1735 3.25 17.3276 3.25H6.66377C4.82645 3.25 3.25 4.65218 3.25 6.50002ZM6.66377 4.75C5.56055 4.75 4.75 5.57189 4.75 6.50002V8.25H19.25V6.50002C19.25 5.58 18.4394 4.75 17.3276 4.75H6.66377ZM4.75 9.75H19.25V17.2522C19.25 18.3837 18.3718 19.25 17.3348 19.25H6.66521C5.62268 19.25 4.75 18.378 4.75 17.2522V9.75Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconJobProgramCode as ReactComponent };
